import * as marietta from '../..';
import { LayerGroup, GridLayer } from '../layer';
import { EventDispatcher } from '../flash/events';
import { BoundInfoCollection } from '../collection';
import { BUILDING_TYPE_MANSION, SITE_INPUT_MODE, WEBCAD_2D_VIEW_INNER_ID, WEBCAD_2D_VIEW_SVG_SELECTOR } from '../Constants';

export default class ScrollerManager extends EventDispatcher {
    /**
    * Constructor
    * @mainLayer 全フロアレイヤー、グリッドレイヤーのラッパーオブジェクト
    */
    plan2DManager: marietta.webcad.manager.Plan2DManager;

    mainLayer: LayerGroup;

    delta: number;

    grid: GridLayer;

    scaleTimerIsPlus: boolean;

    scaleTimer: ReturnType<typeof setInterval> ;

    timePassed: number;

    enlargeUnit: number = 0.1;

    // レイヤードラッグする際の座標計算に使用
    offsetX: number;

    offsetY: number;

    headerHeight: number = (<HTMLElement>document.querySelector('#header')).offsetHeight;

    menuWidth: number = (<HTMLElement>document.querySelector('#itemMenuWrap')).offsetWidth;

    lastTime: number;

    private _scrollEnable: boolean;

    // ピンチズーム（Safari GestureEvent）開始時の倍率
    private initScale: number = 1;

    // ピンチズーム開始時に2指中点の真下にあったmainLayerローカル座標（＝掴んだ点）
    private startLocalPoint: marietta.core.Point = new marietta.core.Point(0, 0);

    nowScaleIndex:number;

    nowScrollPosition = { left: 0, top: 0 };

    public set scrollEnable(value: boolean) {
      this._scrollEnable = value;
    }

    public get scrollEnable(): boolean {
      return this._scrollEnable;
    }

    constructor(_Plan2DManager: marietta.webcad.manager.Plan2DManager, _LayerGroup: LayerGroup) {
      super();
      this._scrollEnable = true;
      this.plan2DManager = _Plan2DManager;
      this.mainLayer = _LayerGroup;
      this.grid = _LayerGroup.grid;

      // ホイールイベント初期化
      // this.mainLayer.viewObj.addEventListener('wheel', this.doMouseWheelAction);
      this.mainLayer.spt.setScrollEvent((e:WheelEvent) => {
        if (this._scrollEnable) {
          this.doMouseWheelAction(e);
        } else {
          e.preventDefault();
        }
      });

      // 拡縮ボタンの初期化
      document.getElementById('btnStageScaleFit').addEventListener('click', this.controlLayerEnlargementFit);

      const { userAgentManager } = marietta.webcad.WebCADGlobal;
      document.querySelector('#btnStageScalePlus').addEventListener(userAgentManager.isPC ? 'mousedown' : 'touchstart', this.onMouseDownEnlargeButton);
      document.querySelector('#btnStageScaleMinus').addEventListener(userAgentManager.isPC ? 'mousedown' : 'touchstart', this.onMouseDownEnlargeButton);
    }

    /**
     * 拡縮ボタンが押された
     * @param JQueryMouseEventObject
     */
    onMouseDownEnlargeButton = (e: Event) => {
      e.preventDefault();

      const time: Date = new Date();
      const nowTime: number = time.getTime();
      if ((nowTime - this.lastTime < 400)) {
        return;
      }

      const isPlus: boolean = ((<HTMLElement>e.currentTarget).getAttribute('id') === 'btnStageScalePlus');
      this.scaleTimerIsPlus = isPlus;

      // 回転の開始
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.addEventListener('touchend', this.onMouseUpEnlargeButton, { passive: false });
        document.addEventListener('touchcancel', this.onMouseUpEnlargeButton, { passive: false });
      } else {
        document.addEventListener('mouseup', this.onMouseUpEnlargeButton);
      }
      ua = null;

      this.scaleTimer = setInterval(() => this.onScaleInterval(), 50);
      this.timePassed = 0;

      // １回目の処理
      this.onScaleInterval(true);
      this.lastTime = nowTime;
    }

    /**
     * 回転
     */
    onScaleInterval(force: boolean = false) {
      this.timePassed += 50;
      // 時間と共に回転を早くする
      if (this.timePassed < 500 && force === false) {
        return;
      }

      if (this.scaleTimerIsPlus) {
        this.controlLayerEnlargementPlus();
      } else {
        this.controlLayerEnlargementMinus();
      }
    }

    /**
     * マウスがUPされた
     * @param {MouseEvent} e
     */
    onMouseUpEnlargeButton = (e: MouseEvent) => {
      e.preventDefault();
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.removeEventListener('touchend', this.onMouseUpEnlargeButton);
        document.removeEventListener('touchcancel', this.onMouseUpEnlargeButton);
      } else {
        document.removeEventListener('mouseup', this.onMouseUpEnlargeButton);
      }
      ua = null;

      clearInterval(this.scaleTimer);
    }

    // ###############   ビュー管理 ###############

    doMouseWheelAction = (e) => {
      // マウスの位置がまだ取得できない場合は、無視
      if (this.mainLayer.spt.mouseX < 0) return;

      e.preventDefault();

      // 最初のマウス位置保持（LayerGroup内の座標に変換）
      const currentScrollPosition: marietta.core.Point = new marietta.core.Point(document.getElementById('webcad2dViewInner').scrollLeft, document.getElementById('webcad2dViewInner').scrollTop);
      const motoMouse: marietta.core.Point = new marietta.core.Point(this.mainLayer.spt.mouseX, this.mainLayer.spt.mouseY);
      const motoLocalPoint: marietta.core.Point = new marietta.core.Point(motoMouse.x, motoMouse.y);
      const motoGlobalPoint: marietta.core.Point = this.mainLayer.spt.localToGlobal(motoLocalPoint);

      // 拡大縮小
      this.delta = e.deltaY;
      if (this.delta > 0) {
        this.controlLayerEnlargement(-this.enlargeUnit);
      } else {
        this.controlLayerEnlargement(this.enlargeUnit);
      }

      // 元のマウス位置（LayerGroup内の座標）が全体で見たとき、どの位置になったかを計測
      const atoLocalPoint: marietta.core.Point = new marietta.core.Point(motoMouse.x, motoMouse.y);
      const atoGlobalPoint: marietta.core.Point = this.mainLayer.spt.localToGlobal(atoLocalPoint);

      const idoX: number = atoGlobalPoint.x - motoGlobalPoint.x;
      const idoY: number = atoGlobalPoint.y - motoGlobalPoint.y;

      // 元の位置に、移動した距離を足しこむ
      document.getElementById('webcad2dViewInner').scrollLeft = (currentScrollPosition.x + idoX);
      document.getElementById('webcad2dViewInner').scrollTop = (currentScrollPosition.y + idoY);
    }

    /**
     * スクロール位置の変更
     * @param {number} x
     * @param {number} y
     */
    setScrollPosition=(x: number, y: number): void => {
      document.getElementById('webcad2dViewInner').scrollLeft = x;
      document.getElementById('webcad2dViewInner').scrollTop = y;
    }

    /**
     * スクロールの中心座標を取得する
     */
    getScrollCenterPoint = (): marietta.core.Point => {
      let motoCenter: marietta.core.Point;
      const { currentItem } = marietta.webcad.WebCADGlobal.itemManager;
      if (currentItem) {
        // 選択中のアイテムが有る場合は中心座標を取得
        if (currentItem instanceof marietta.webcad.item.Room) {
          const itemBound = currentItem.viewObj.getBoundingClientRect();
          const minPoint = new marietta.core.Point(currentItem.spt.x, currentItem.spt.y);
          const maxPoint = new marietta.core.Point(currentItem.spt.x + itemBound.width / marietta.webcad.WebCADGlobal.scaleSize, currentItem.spt.y + itemBound.height / marietta.webcad.WebCADGlobal.scaleSize);
          motoCenter = new marietta.core.Point((maxPoint.x + minPoint.x) / 2, (maxPoint.y + minPoint.y) / 2);
        } else {
          motoCenter = new marietta.core.Point(currentItem.spt.x, currentItem.spt.y);
        }
      } else {
        // 表示中のステージの中心座標を取得
        motoCenter = marietta.webcad.util.WebCADUtil.getPointStageCenter();
      }

      return motoCenter;
    }

    /**
     * 拡大
     * */
    controlLayerEnlargementPlus = () => {
      // 最初のマウス位置保持（LayerGroup内の座標に変換）
      const currentScrollPosition: marietta.core.Point = new marietta.core.Point(document.getElementById('webcad2dViewInner').scrollLeft, document.getElementById('webcad2dViewInner').scrollTop);

      const motoCenter: marietta.core.Point = this.getScrollCenterPoint();
      const motoLocalPoint: marietta.core.Point = new marietta.core.Point(motoCenter.x, motoCenter.y);
      const motoGlobalPoint: marietta.core.Point = this.mainLayer.spt.localToGlobal(motoLocalPoint);

      // 拡大縮小
      this.controlLayerEnlargement(0.1);

      // 元のマウス位置（LayerGroup内の座標）が全体で見たとき、どの位置になったかを計測
      const atoLocalPoint: marietta.core.Point = new marietta.core.Point(motoCenter.x, motoCenter.y);
      const atoGlobalPoint: marietta.core.Point = this.mainLayer.spt.localToGlobal(atoLocalPoint);

      const idoX: number = atoGlobalPoint.x - motoGlobalPoint.x;
      const idoY: number = atoGlobalPoint.y - motoGlobalPoint.y;

      // 元の位置に、移動した距離を足しこむ
      document.getElementById('webcad2dViewInner').scrollLeft = (currentScrollPosition.x + idoX);
      document.getElementById('webcad2dViewInner').scrollTop = (currentScrollPosition.y + idoY);

      // 壁リストを処理する
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList && marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList.length > 0) {
        if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects) {
          marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
        }
      }
    }

    /**
     * 縮小
     * */
    controlLayerEnlargementMinus = ():void => {
      // 最初のマウス位置保持（LayerGroup内の座標に変換）
      const currentScrollPosition: marietta.core.Point = new marietta.core.Point(document.getElementById('webcad2dViewInner').scrollLeft, document.getElementById('webcad2dViewInner').scrollTop);

      const motoCenter: marietta.core.Point = this.getScrollCenterPoint();
      const motoLocalPoint: marietta.core.Point = new marietta.core.Point(motoCenter.x, motoCenter.y);
      const motoGlobalPoint: marietta.core.Point = this.mainLayer.spt.localToGlobal(motoLocalPoint);

      // 拡大縮小
      this.controlLayerEnlargement(-0.1);

      // 元のマウス位置（LayerGroup内の座標）が全体で見たとき、どの位置になったかを計測
      const atoLocalPoint: marietta.core.Point = new marietta.core.Point(motoCenter.x, motoCenter.y);
      const atoGlobalPoint: marietta.core.Point = this.mainLayer.spt.localToGlobal(atoLocalPoint);

      const idoX: number = atoGlobalPoint.x - motoGlobalPoint.x;
      const idoY: number = atoGlobalPoint.y - motoGlobalPoint.y;

      // 元の位置に、移動した距離を足しこむ
      document.getElementById('webcad2dViewInner').scrollLeft = (currentScrollPosition.x + idoX);
      document.getElementById('webcad2dViewInner').scrollTop = (currentScrollPosition.y + idoY);
      // 壁リストを処理する
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList && marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList.length > 0) {
        if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects) {
          marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
        }
      }
    }

    /**
     * FIT
     * */
    controlLayerEnlargementFit = ():void => {
    marietta.webcad.WebCADGlobal.overlapItemList.hideList();
      // スケールと原点を元に戻す
      this.setScale(1);
      document.getElementById('webcad2dViewInner').scrollLeft = 0;
      document.getElementById('webcad2dViewInner').scrollTop = 0;

      let scrollWidth: number;
      let scrollHeight: number;

      // 領域情報の取得
      let myBounds: BoundInfoCollection = marietta.webcad.WebCADGlobal.layerGroup.getBoundInfo();

      if (myBounds.width > 0) {
        // 間取りを画面中心に移動する
        this.mainLayer.convertAllToCenter();

        // 適当な拡大率にする
        const fitScale: number = Math.min((marietta.webcad.WebCADGlobal.viewWidth - (marietta.webcad.WebCADGlobal.LAYER_MARGIN * 2) / marietta.webcad.WebCADGlobal.scaleSize) / myBounds.width,
          (marietta.webcad.WebCADGlobal.viewHeight - (marietta.webcad.WebCADGlobal.LAYER_MARGIN * 2) / marietta.webcad.WebCADGlobal.scaleSize) / myBounds.height);
        this.setScale(fitScale);

        myBounds = marietta.webcad.WebCADGlobal.layerGroup.getBoundInfo();

        // オブジェクトの中心点
        const center: marietta.core.Point = myBounds.center as marietta.core.Point;

        scrollWidth = (marietta.webcad.WebCADGlobal.LAYER_SIZE_W * marietta.webcad.WebCADGlobal.scaleSize - document.getElementById('webcad2dViewInner').clientWidth);
        scrollHeight = (marietta.webcad.WebCADGlobal.LAYER_SIZE_H * marietta.webcad.WebCADGlobal.scaleSize - document.getElementById('webcad2dViewInner').clientHeight);
        const centerX: number = center.x - (marietta.webcad.WebCADGlobal.LAYER_SIZE_W / 2) * marietta.webcad.WebCADGlobal.scaleSize;
        const centerY: number = center.y - (marietta.webcad.WebCADGlobal.LAYER_SIZE_H / 2) * marietta.webcad.WebCADGlobal.scaleSize;

        document.getElementById('webcad2dViewInner').scrollLeft = (scrollWidth / 2 + centerX);
        document.getElementById('webcad2dViewInner').scrollTop = (scrollHeight / 2 + centerY);
      } else {
        this.setScale(1);

        scrollWidth = (marietta.webcad.WebCADGlobal.LAYER_SIZE_W * marietta.webcad.WebCADGlobal.scaleSize - document.getElementById('webcad2dViewInner').clientWidth);
        scrollHeight = (marietta.webcad.WebCADGlobal.LAYER_SIZE_H * marietta.webcad.WebCADGlobal.scaleSize - document.getElementById('webcad2dViewInner').clientHeight);
        document.getElementById('webcad2dViewInner').scrollLeft = (scrollWidth / 2);
        document.getElementById('webcad2dViewInner').scrollTop = (scrollHeight / 2);
      }

      // カレントをなくす
      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
      marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;

      // 壁リストを処理する
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList && marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList.length > 0) {
        if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects) {
          marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
        }
      }

      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
        marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
      }
    }

    /**
     * 拡大・縮小コントロール
     * */
    controlLayerEnlargement(numValue: number):void {
      this.setScale(marietta.webcad.WebCADGlobal.scaleSize + numValue);
    }

    /**
     * クライアント座標（viewport基準）をmainLayerのローカル座標へ変換する。
     * Stage.offsetX/Yはscrollイベントでしか更新されず、ピンチ中の連続する
     * gesturechangeの間では古い値になり得るため使わない。常に最新のレイアウトが
     * 反映されるSVG要素のgetBoundingClientRect()を基準にする。
     */
    private clientPointToMainLayerLocal(clientX: number, clientY: number): marietta.core.Point {
      const svgRect: DOMRect = document.querySelector(WEBCAD_2D_VIEW_SVG_SELECTOR).getBoundingClientRect();
      const globalPoint: marietta.core.Point = new marietta.core.Point(clientX - svgRect.left, clientY - svgRect.top);
      return this.mainLayer.spt.globalToLocal(globalPoint);
    }

    /**
     * ピンチズーム開始（Safari GestureEvent の gesturestart）。
     * iPad等のタブレットで、作図ビュー(#webcad2dViewInner)上の2本指ジェスチャを検出する。
     * 開始時点で2指中点の真下にあるローカル座標を「掴んだ点」として記録する。
     * gesturechange/gestureendはこのタイミングで登録する。
     */
    public startHandler = (e: any): void => {
      if (!this.scrollEnable) return;

      e.preventDefault();
      e.stopPropagation();
      this.initScale = marietta.webcad.WebCADGlobal.scaleSize;
      this.startLocalPoint = this.clientPointToMainLayerLocal(e.clientX, e.clientY);

      const con: HTMLElement = document.getElementById(WEBCAD_2D_VIEW_INNER_ID);
      con.addEventListener('gesturechange', this.moveHandler);
      con.addEventListener('gestureend', this.endHandler);
    }

    /**
     * ピンチズーム中（Safari GestureEvent の gesturechange）。
     * e.scale（開始時=1.0の累積スケール）で倍率を反映した後、開始時に掴んだ点が
     * 常に「現在の2指中点」の真下に来るようスクロール位置を絶対値で合わせ込む。
     * 前フレームとの差分を足し込む方式だと、参照する基準値のズレが毎フレーム
     * 蓄積して焦点がずれていくため、毎フレーム絶対値で決め直す（パンも中点の
     * 移動として同じ式で自動的に反映される）。
     */
    public moveHandler = (e: any): void => {
      e.preventDefault();
      e.stopPropagation();
      const viewInner: HTMLElement = document.getElementById(WEBCAD_2D_VIEW_INNER_ID);
      // スクロール中にスクロールバーが画面中央に出てくるのを防ぐ
      viewInner.style.overflow = 'hidden';

      // 新しいスケール値（開始時スケール × ジェスチャの累積スケール）
      this.setScale(this.initScale * e.scale);

      // ズーム後の「掴んだ点」のグローバル座標（スクロールコンテンツ座標）
      const grabbedGlobalPoint: marietta.core.Point = this.mainLayer.spt.localToGlobal(this.startLocalPoint);

      // 掴んだ点の現在のクライアント位置は (svgRect.left + grabbedGlobalPoint.x)。
      // これが現在の2指中点(e.clientX/Y)と一致するよう、差分だけスクロールを動かす。
      const svgRect: DOMRect = document.querySelector(WEBCAD_2D_VIEW_SVG_SELECTOR).getBoundingClientRect();
      this.setScrollPosition(
        viewInner.scrollLeft + (svgRect.left + grabbedGlobalPoint.x - e.clientX),
        viewInner.scrollTop + (svgRect.top + grabbedGlobalPoint.y - e.clientY),
      );
    }

    /**
     * ピンチズーム終了（Safari GestureEvent の gestureend）。
     */
    public endHandler = (e: any): void => {
      e.preventDefault();
      e.stopPropagation();
      document.getElementById(WEBCAD_2D_VIEW_INNER_ID).style.overflow = 'scroll';

      const con: HTMLElement = document.getElementById(WEBCAD_2D_VIEW_INNER_ID);
      con.removeEventListener('gesturechange', this.moveHandler);
      con.removeEventListener('gestureend', this.endHandler);
    }

    /**
     * 拡大・縮小コントロール
     * */
    setScale(numValue: number) {
      marietta.webcad.WebCADGlobal.scaleSize = numValue;

      // 制限
      if (marietta.webcad.WebCADGlobal.scaleSize < marietta.webcad.WebCADGlobal.LAYER_SCALE_MIN) { marietta.webcad.WebCADGlobal.scaleSize = marietta.webcad.WebCADGlobal.LAYER_SCALE_MIN; } // 最小
      if (marietta.webcad.WebCADGlobal.scaleSize > marietta.webcad.WebCADGlobal.LAYER_SCALE_MAX) { marietta.webcad.WebCADGlobal.scaleSize = marietta.webcad.WebCADGlobal.LAYER_SCALE_MAX; } // 最大

      this.mainLayer.spt.scaleX = marietta.webcad.WebCADGlobal.scaleSize;
      this.mainLayer.spt.scaleY = marietta.webcad.WebCADGlobal.scaleSize;
      this.mainLayer.spt.update();

      // SVGの幅・高さをlayerGroupのサイズに合わせる
      document.querySelector('#webcad2dViewInner > svg').setAttribute('width', (marietta.webcad.WebCADGlobal.LAYER_SIZE_W * marietta.webcad.WebCADGlobal.scaleSize).toString());
      document.querySelector('#webcad2dViewInner > svg').setAttribute('height', (marietta.webcad.WebCADGlobal.LAYER_SIZE_H * marietta.webcad.WebCADGlobal.scaleSize).toString());

      // グリッド線幅更新
      marietta.webcad.WebCADGlobal.layerGroup.grid.lineStrokeUpdate();

      // 寸法線幅更新
      // (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor).layer_measure as marietta.webcad.layer.MeasureLayer).measureLineStrokeUpdate();

      // ガイドラインテキスト更新
      if (marietta.webcad.WebCADGlobal.itemManager.itemController && marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerWithGuide) {
        (marietta.webcad.WebCADGlobal.itemManager.itemController as marietta.webcad.control.ItemControllerWithGuide).itemguide.upadateDistanceText();
      }

      // アイテムコントローラーの更新
      try {
        if (marietta.webcad.WebCADGlobal.itemManager.itemController && marietta.webcad.WebCADGlobal.itemManager.itemController.updatePickers) marietta.webcad.WebCADGlobal.itemManager.itemController.updatePickers();
      } catch (error) {
        console.error(error);
      }

      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup) {
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.updateTranslate();
      }

      // k.kubonaka WEBCAD-1148対応
      this.dispatchEvent(new marietta.webcad.flash.events.Event(marietta.webcad.flash.events.Event.CHANGE_SCALE));
    }

    /**
     * レイヤーをドラッグ開始
     */
    startDragMainLayer = (e) => {
      this.offsetX = (e.clientX - this.menuWidth) + document.getElementById('webcad2dViewInner').scrollLeft;
      this.offsetY = (e.clientY - this.headerHeight) + document.getElementById('webcad2dViewInner').scrollTop;

      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.mainLayer.spt.element.addEventListener('touchmove', this.onMouseMove);
        this.mainLayer.spt.element.addEventListener('touchend', this.stopDragMainLayer);
      } else {
        this.mainLayer.spt.element.addEventListener('mousemove', this.onMouseMove);
        this.mainLayer.spt.element.addEventListener('mouseup', this.stopDragMainLayer);
      }

      // カーソルを掴んでいる状態に変更
      (<SVGElement> document.querySelector('#webcad2dViewInner > svg')).style.cursor = `url(${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/grabbing.cur), move`;
    }

    /**
     * レイヤーをドラッグ中
     */
    onMouseMove = (e: MouseEvent) => {
      const diffX: number = this.offsetX - (e.clientX - this.menuWidth);
      const diffY: number = this.offsetY - (e.clientY - this.headerHeight);

      document.getElementById('webcad2dViewInner').scrollLeft = diffX;
      document.getElementById('webcad2dViewInner').scrollTop = diffY;
    }

    /**
     * レイヤーをドラッグ終了
     */
    stopDragMainLayer = () => {
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.mainLayer.spt.element.removeEventListener('touchmove', this.onMouseMove);
        this.mainLayer.spt.element.removeEventListener('touchend', this.stopDragMainLayer);
      } else {
        this.mainLayer.spt.element.removeEventListener('mousemove', this.onMouseMove);
        this.mainLayer.spt.element.removeEventListener('mouseup', this.stopDragMainLayer);
      }

      // アクションモードアップデート
      const mode = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode;
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = mode;
    }

    /**
     * 現在の設定の取得
     */
    static get currentSetting(): marietta.webcad.collection.ScrollSettingCollection {
      const currentScrollPosition: marietta.core.Point = new marietta.core.Point(document.getElementById('webcad2dViewInner').scrollLeft, document.getElementById('webcad2dViewInner').scrollTop);
      const setting: marietta.webcad.collection.ScrollSettingCollection = new marietta.webcad.collection.ScrollSettingCollection(currentScrollPosition.x, currentScrollPosition.y, marietta.webcad.WebCADGlobal.scaleSize);
      return setting;
    }

    /**
     * 印刷用
     * 左上に移動、XMLファイルに指定されたサイズに変更する
     * 印刷が終わったら元の状態に戻す
     */
    moveTopLeftAndFit(floor: number = null): {x: number, y: number} {
      // 現在の状態を保持
      this.nowScaleIndex = marietta.webcad.WebCADGlobal.scaleSize;
      this.nowScrollPosition = {
        left: $('#webcad2dViewInner').scrollLeft(),
        top: $('#webcad2dViewInner').scrollTop(),
      };
      // スケールと原点を元に戻す
      this.setScale(1);
      $('#webcad2dViewInner').scrollLeft(1).scrollTop(1);
      // 間取りを画面中心に移動する
      const moveDistance = this.mainLayer.convertAllToLeftTop(floor);
      return moveDistance;
    }
}
